const Message = props => {
    return (
        <div className={props.isMe ? "my-message" : "user-message"}>
            <p className="message-author">{props.from}</p>
            <p className="message-text">{props.text}</p>
        </div>
    );
}

export default Message;